// Jeden pohled na práci ve čtyřech řezech. Dřív to byly čtyři samostatné stránky
// (/zakazky, /tabule, /gantt, /planovani), které odpovídaly na tutéž otázku
// „co se děje a co mám dělat" — uživatel musel dopředu vědět, kterou otevřít.
// Teď je to jedna stránka s přepínačem; staré cesty na ni přesměrovávají.
import type { Capability } from '../../components/nav';

// 'tabule' už není samostatný pohled (je to seskupení Dílny „podle stavu"),
// zůstává jen kvůli starým odkazům ?pohled=tabule — WorkPage ho přesměruje.
export type WorkView = 'dnes' | 'seznam' | 'dilna' | 'tabule' | 'harmonogram' | 'stroje' | 'kapacita';

export interface WorkViewMeta {
  id: WorkView;
  label: string;
  icon: string;
  // Doplněk k nadpisu — říká, co v tomhle řezu uvidím a co s ním můžu dělat.
  hint: string;
  cap: Capability;
  // Gantt a tabule potřebují celou šířku, seznam se čte líp úzký.
  wide: boolean;
}

export const WORK_VIEWS: WorkViewMeta[] = [
  {
    id: 'dnes',
    label: 'Dnes',
    icon: '📅',
    hint: 'Co v dílně běží dnes, co začíná příští pracovní den a co stojí — seřazené podle toho, co hoří.',
    cap: 'production',
    wide: true,
  },
  {
    id: 'seznam',
    label: 'Seznam',
    icon: '📋',
    hint: 'Všechny zakázky se stavem, klientem a termínem.',
    cap: 'production',
    wide: false,
  },
  {
    id: 'dilna',
    label: 'Dílna',
    icon: '🪚',
    hint: 'Tabule práce v dílně — seskup podle fází, stavu nebo lidí a táhni karty, jak práce postupuje.',
    cap: 'production',
    wide: true,
  },
  {
    id: 'harmonogram',
    label: 'Harmonogram',
    icon: '🗓️',
    hint: 'Táhni fázi = posun, okraje = délka, lišta zakázky = posun všech fází, klik = otevřít.',
    cap: 'production',
    wide: true,
  },
  {
    id: 'stroje',
    label: 'Stroje',
    icon: '🛠️',
    hint: 'Vytížení strojů po dnech — rezervace z fází proti denní kapacitě, servis a kolize.',
    cap: 'production',
    wide: true,
  },
  {
    id: 'kapacita',
    label: 'Kapacita',
    icon: '👥',
    hint: 'Týdenní vytížení lidí — zbývající práce z odhadů fází vs. kapacita podle směn a dovolených.',
    cap: 'finance',
    wide: true,
  },
];

export const DEFAULT_VIEW: WorkView = 'seznam';
// Na telefonu je výchozí přehled Dnes — Gantt ani tabulka se tam nedají pohodlně číst.
export const PHONE_DEFAULT_VIEW: WorkView = 'dnes';
export const isPhone = () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches;

export const isWorkView = (v: unknown): v is WorkView =>
  typeof v === 'string' && (v === 'tabule' || WORK_VIEWS.some((w) => w.id === v));

// Pohledy, na které uživatel s danými oprávněními dosáhne.
export const allowedViews = (caps: Capability[]): WorkViewMeta[] =>
  WORK_VIEWS.filter((v) => caps.includes(v.cap));
